// extracted by mini-css-extract-plugin
export default {"banner":"styles__banner___r47Ne","bannerStripe":"styles__bannerStripe___GzbuT"};